import React from 'react';

import {
  FileExcelOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FileZipOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';

import {
  ARCHIVE_FILE_EXTENSIONS,
  IMAGE_FILE_EXTENSIONS,
  PDF_FILE_EXTENSIONS,
  SPREADSHEET_FILE_EXTENSIONS,
  TEXT_FILE_EXTENSIONS,
  WORD_FILE_EXTENSIONS,
} from './constants';

type AttachmentFileIconProps = {
  fileExtension?: string | null;
};

const AttachmentFileIcon = ({ fileExtension }: AttachmentFileIconProps) => {
  const normalizedExtension = (fileExtension || '').toLowerCase();

  if (PDF_FILE_EXTENSIONS.includes(normalizedExtension)) {
    return <FilePdfOutlined />;
  }

  if (IMAGE_FILE_EXTENSIONS.includes(normalizedExtension)) {
    return <FileImageOutlined />;
  }

  if (WORD_FILE_EXTENSIONS.includes(normalizedExtension)) {
    return <FileWordOutlined />;
  }

  if (SPREADSHEET_FILE_EXTENSIONS.includes(normalizedExtension)) {
    return <FileExcelOutlined />;
  }

  if (ARCHIVE_FILE_EXTENSIONS.includes(normalizedExtension)) {
    return <FileZipOutlined />;
  }

  if (TEXT_FILE_EXTENSIONS.includes(normalizedExtension)) {
    return <FileTextOutlined />;
  }

  return <PaperClipOutlined />;
};

export default AttachmentFileIcon;
